import { useCallback } from 'react'

import type { ChatMessageResponse } from '../types'

interface UseNavigateToMessageOptions {
	messages: ChatMessageResponse[]
	jumpToMessage: (messageId: string) => Promise<void>
	scrollToExistingMessage: (messageId: string) => boolean
}

interface UseNavigateToMessageReturn {
	navigateToMessage: (messageId: string) => Promise<void>
}

export function useNavigateToMessage({
	messages,
	jumpToMessage,
	scrollToExistingMessage,
}: UseNavigateToMessageOptions): UseNavigateToMessageReturn {
	const navigateToMessage = useCallback(
		async (messageId: string) => {
			// Check if message exists in current messages array
			const messageExists = messages.some((msg) => msg.id === messageId)

			if (messageExists) {
				// Message is already loaded, just scroll to it
				scrollToExistingMessage(messageId)
			} else {
				// Message not loaded, update query string to trigger refetch
				// useScrollToBottom will handle the scroll after fetch completes
				await jumpToMessage(messageId)
			}
		},
		[messages, jumpToMessage, scrollToExistingMessage],
	)

	return {
		navigateToMessage,
	}
}
